import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ITag } from '@models/shared/manage/tags.model';
import { HTTPResponse } from '@models/shared/http/Response';
import { APP_CONFIG } from '@services/tokens/app-config.token';

@Injectable({
  providedIn: 'root'
})
export class TagApiService {
  private appConfig = inject(APP_CONFIG);
  private http = inject(HttpClient);

  private readonly baseURL = this.appConfig.apiUrl + 'manage/';

  getAllTags(): Observable<HTTPResponse<ITag[]>> {
    const url = `${this.baseURL}tags`;
    return this.http.get<HTTPResponse<ITag[]>>(url);
  }

  createTag(name: string): Observable<any> {
    const url = `${this.baseURL}tags`;
    return this.http.post(url, { name });
  }

  updateTag(tagId: number, newName: string): Observable<any> {
    const url = `${this.baseURL}tags/${tagId}`;
    return this.http.put(url, { name: newName });
  }

  deleteTag(tagId: number): Observable<any> {
    const url = `${this.baseURL}tags/${tagId}`;
    return this.http.delete(url);
  }

  attachTag(contactId: number, tagId: number): Observable<any> {
    const url = `${this.baseURL}tags/attach/${contactId}/${tagId}`;
    return this.http.post(url, {});
  }

  detachTag(contactId: number, tagId: number): Observable<any> {
    const url = `${this.baseURL}tags/detach/${contactId}/${tagId}`;
    return this.http.delete(url);
  }

  getContactsByTag(tagId: number): Observable<any> {
    const url = `${this.baseURL}tags/get-contacts/${tagId}`;
    return this.http.get(url);
  }

  getTagsByContactId(contactId: number): Observable<HTTPResponse<ITag[]>> {
    const url = `${this.baseURL}tags/get-tags/${contactId}`;
    return this.http.get<HTTPResponse<ITag[]>>(url);
  }
}
